export const bulletsCardFragment = `
  fragment bulletsCardFragment on BulletsCardRecord {
    content
    image {
      responsiveImage(
        imgixParams: {
          auto: format,
          fit: crop,
          h: 68,
          q: 45,
          w: 68
        }
      ) {
        ...responsiveImageFragment
      }
    }
    tag
    target {
      ...targetFragment
    }
    title
  }
`;

export const bulletsFragment = `
  fragment bulletsFragment on BulletsModuleBlockRecord {
    button {
      ...buttonFragment
    }
    cardSize
    content {
      ... on BulletsModuleCardRecord {
        cards {
          ...bulletsCardFragment
        }
      }
      ... on BulletsModuleTabBlockRecord {
        tabs {
          cards {
            ...bulletsCardFragment
          }
          title
        }
      }
    }
    headingProps {
      textStyle
    }
    moduleFormat {
      ...moduleFormatFragment
    }
    subtitle
    title
  }

  ${bulletsCardFragment}
`;
